import React from 'react';
import WindowDimensions from './WindowDimensions';

const withWindowDimensions = Component => {
  class TrackWinDimensions extends React.Component {
    render() {
      const { forwardedRef, ...rest } = this.props;
      return (
        <WindowDimensions
          render={dimensions => (
            <Component ref={forwardedRef} dimensions={dimensions} {...rest} />
          )}
        />
      );
    }
  }

  return React.forwardRef((props, ref) => {
    return <TrackWinDimensions {...props} forwardedRef={ref} />;
  });
};

export default withWindowDimensions;
